import {ACTIONS, INITIAL_STATE,START_OVER_STATE, DEFAULT_STATE_VALUE,DEFAULT_ATTR_VALUE} from '../constants.js'
import {filter} from './utils'
import {param2sku,sku2array} from '../logic/sku-ver3.js'
import {
  get_default_sku
} from './utils';
function checkNewValue(state,newstate,value) {
  if (value in newstate) return newstate[value]
  return state[value]
}



function controlLogic (state,action) {
  let newState={}
  //console.log('start reducer control logic',action,state) 
 
  let option_ring_view1=["ce","cec","ds","dctw","dq","rmet","rmetc","hmetc","rs","sh"] 
  let option_ring_view2=["ren"] 
  let option_ring_view3=["rset","rsetc","rsetl", ] 
  let option_band_view1=["band","bmet","bmetc",] 
  let option_band_view2=["ben"] 
  let option_band_view3=["bset","bsetc","bsetl",] 
  let option_head=["head"]
  let option_head_view2=["SS1","SS2","C1"]
  let option_headc=["headc"]
  // change to active view =1 if sc changed

  
  if (state['band'] ==='0') 
    {newState['max_view']=3}
  else
    {newState['max_view']=5}

  if (action.attr==='band' && action.value ==='0')     {
  //  console.log('condition 1')
    newState['max_view']=3
    newState['active_view']=1
  }
  else 
  if (action.attr==='band' && action.value !=='0')     {
    //console.log('condition 2')
    newState['max_view']=5
    newState['active_view']=4
    newState['active_view4']=1
  }
  else 
  if (option_ring_view1.includes(action.attr) && state['band'] === '0' )     {
    //console.log('condition 3')
    newState['active_view']=1
  }
  else 
  if (option_ring_view1.includes(action.attr) && state['band'] !== '0' )     {
    //console.log('condition 4')
    newState['active_view']=1
    //newState['active_view4']=1
  }
  else 
  if (option_ring_view2.includes(action.attr) && state['band'] === '0' )     {
    //console.log('condition 5')
    newState['active_view']=2
  }
  else 
  if (option_ring_view2.includes(action.attr) && state['band'] !== '0' )     {
    //console.log('condition 6')
    newState['active_view']=2
    //newState['active_view4']=2
  }
  else 
  if (option_ring_view3.includes(action.attr) && state['band'] === '0' )     {
    //console.log('condition 7')
    newState['active_view']=3
  }
  else 
  if (option_ring_view3.includes(action.attr) && state['band'] !== '0' )     {
    //console.log('condition 8')
    newState['active_view']=3
    //newState['active_view4']=3
  }
  else 
  if (option_band_view1.includes(action.attr)  )     {
    //console.log('condition 9')
    newState['active_view']=4
    newState['active_view4']=1
  }
  else 
  if (option_band_view2.includes(action.attr)  )     {
    //console.log('condition 10')
    newState['active_view']=5
    newState['active_view5']=2
  }
  else 
  if (option_band_view3.includes(action.attr)  )     {
    //console.log('condition 11')
    newState['active_view']=5
    newState['active_view5']=2
  }
  else 
  if (option_head.includes(action.attr) && option_head_view2.includes(action.value) && state['band'] === '0'  )     {
    //console.log('condition 12')
    newState['active_view']=2
  }
  else 
  if (option_head.includes(action.attr) && option_head_view2.includes(action.value) && state['band'] !== '0'  )     {
    //console.log('condition 13')
    newState['active_view']=2
    //newState['active_view4']=2
  }
  else 
  if (option_head.includes(action.attr) && !option_head_view2.includes(action.value) && state['band'] === '0'  )     {
   // console.log('condition 14')
    newState['active_view']=1
  }
  else 
  if (option_head.includes(action.attr) && !option_head_view2.includes(action.value) && state['band'] !== '0'  )     {
    //console.log('condition 15')
    newState['active_view']=1
    //newState['active_view4']=1
  }
  else 
  if (option_headc.includes(action.attr) && option_head_view2.includes(state['head']) && state['band'] === '0'  )     {
    //console.log('condition 16')
    newState['active_view']=2
  }
  else 
  if (option_headc.includes(action.attr) && option_head_view2.includes(state['head']) && state['band'] !== '0'  )     {
   // console.log('condition 17')
    newState['active_view']=2
    //newState['active_view4']=2
  }
  else 
  if (option_headc.includes(action.attr) && !option_head_view2.includes(state['head']) && state['band'] === '0'  )     {
    //console.log('condition 18')
    newState['active_view']=1
  }
  else 
  if (option_headc.includes(action.attr) && !option_head_view2.includes(state['head']) && state['band'] !== '0'  )     {
    //console.log('condition 19')
    newState['active_view']=1
    //newState['active_view4']=1
  }
  //console.log('after view logic',newState['ud'],state['ud'],newState,action,state,action.attr,option_headc.includes(action.attr) ,
  //option_head_view2.includes(state['head']) , state['band'] ) 
 


  let res_options={}
  
  // main logic to update  available options based on style json 
  // with attribute effect_attr and effect_value in options with type 'control'
  // see template in admin-internal-template

  if (state.hasOwnProperty('options_all') && state['options_all'].indexOf(action.attr)!== -1) {
    //console.log('LOGIC start')   
    if (state['options_'+action.attr].type ==='control') {
       let options = state['options_'+action.attr].options
       //console.log('LOGIC show true in options1',options,action)
       for (let i in options ){
         if (options[i].value.toString() === action.value.toString()) {
          let option = options[i].effect
          //console.log('LOGIC show true in options2',option)
          for (let j in option) {
           if (option[j].hasOwnProperty('option')){
         //   console.log('HAS OPTION',option[j],res_options)
            // optionSet and options
            for (let l in option[j].optionSet) {
              if (!res_options.hasOwnProperty(option[j].optionSet[l])){
                res_options[option[j].optionSet[l]] = state['options_'+ option[j].optionSet[l]]
              }  
              for (let k in option[j].option ) {
            //    console.log('candidate k',k,option[j].option,option[j].optionSet[l]) 
               // l is all optionSet, k is all options 
               for (let m in res_options[option[j].optionSet[l]].options ) {
              //  console.log('candidate m',m,res_options[option[j].optionSet[l]].options[m].value,res_options[option[j].optionSet[l]].options[m].value ,option[j].option[k]) 
                if  (res_options[option[j].optionSet[l]].options[m].value ===option[j].option[k]) {
                //  console.log('TRY set one option in menu',option[j].optionSet[l],res_options[option[j].optionSet[l]].options[m],option[j].effect_value,option[j]) 
                  if (!option[j].hasOwnProperty('if_attr'))
                  {
                  //  console.log('start NO IF-ATTR',DEFAULT_ATTR_VALUE.hasOwnProperty(option[j].optionSet[l]),option[j].effect_attr, option[j].effect_value) 
                    // no if_attr
                  if (DEFAULT_ATTR_VALUE.hasOwnProperty(option[j].optionSet[l])&& option[j].effect_attr ==='show' && option[j].effect_value ===false)
                   {//  console.log('NO IF_ATTR set default value in menu',option[j].optionSet[l],DEFAULT_ATTR_VALUE[option[j].optionSet[l]])
                      res_options[option[j].optionSet[l]].options[m][option[j].effect_attr] =option[j].effect_value
                      //console.log('Option',res_options[option[j].optionSet[l]].options[m][option[j].effect_attr],'=>',option[j].effect_value) 
                      //console.log('Change if match',state[option[j].optionSet[l]], option[j].option[k],option[j]) 
                      if (state[option[j].optionSet[l]] === option[j].option[k] )
                       {

                      //console.log("side effect for",option[j].optionSet[l],res_options) 
                      newState[option[j].optionSet[l]]=DEFAULT_ATTR_VALUE[option[j].optionSet[l]]
                      if (option[j].optionSet[l] === 'rset'){
                        //res_options['rsetc'].options['show'] = false
                        res_options['rsetc'] = state['options_rsetc']
                        res_options['rsetc']['show'] = false
                        //res_options[option[j].optionSet[l]].options[m][option[j].effect_attr] =option[j].effect_value
                        newState['rsetc']=DEFAULT_ATTR_VALUE['rsetc']
                      }
                      if (option[j].optionSet[l] === 'bset'){
                        newState['bsetc']=DEFAULT_ATTR_VALUE['bsetc']
                        newState['bsetl']=DEFAULT_ATTR_VALUE['bsetl']
                      }
                      
                      if (option[j].optionSet[l] === 'pkbc')
                        newState['pkbc']=DEFAULT_ATTR_VALUE['pkbc']
                      if (option[j].optionSet[l] === 'ren')
                        newState['renl']=DEFAULT_ATTR_VALUE['renl']
                      if (option[j].optionSet[l] === 'ben')
                        newState['benl']=DEFAULT_ATTR_VALUE['benl']
                        //console.log('reducer',newState)
                      }
                      
                      
                  }
                  else if (DEFAULT_ATTR_VALUE.hasOwnProperty(option[j].optionSet[l])&& option[j].effect_attr ==='show' && option[j].effect_value ===true)
                   {//  console.log('NO IF_ATTR set default value in menu',option[j].optionSet[l],DEFAULT_ATTR_VALUE[option[j].optionSet[l]])
                      res_options[option[j].optionSet[l]].options[m][option[j].effect_attr] =option[j].effect_value
                    //  console.log('Option TRUE',res_options[option[j].optionSet[l]].options[m][option[j].effect_attr],'=>',option[j].effect_value) 
                    if (option[j].optionSet[l] === 'bset'){
                      newState['bsetc']=DEFAULT_ATTR_VALUE['bsetc']
                      newState['bsetl']=DEFAULT_ATTR_VALUE['bsetl']
                    }
                    if (option[j].optionSet[l] === 'rset'){
                      newState['rsetc']=DEFAULT_ATTR_VALUE['rsetc']
                      newState['rsetl']=DEFAULT_ATTR_VALUE['rsetl']
                    }
                    if (option[j].optionSet[l] === 'pkbc')
                      newState['pkbc']=DEFAULT_ATTR_VALUE['pkbc']
                    if (option[j].optionSet[l] === 'ren')
                      newState['renl']=DEFAULT_ATTR_VALUE['renl']
                    if (option[j].optionSet[l] === 'ben')
                      newState['benl']=DEFAULT_ATTR_VALUE['benl']
                    
                    console.log('reducer2',newState) 
                      
                  }
                }
                // if_attr found
                else {
                 // console.log('start IF-ATTR',option[j],state) 
                  if (option[j].if_value.indexOf(state[option[j].if_attr]) !== -1 && 
                  DEFAULT_ATTR_VALUE.hasOwnProperty(option[j].optionSet[l]))
                  { 
                    res_options[option[j].optionSet[l]].options[m][option[j].effect_attr] =option[j].effect_value
                  //  console.log('cond met',state[option[j].if_attr ],'in',option[j].if_value)
                  /*  console.log('update value if',
                    option[j].effect_attr,'is show',
                    option[j].effect_value,'is  false',
                    DEFAULT_ATTR_VALUE.hasOwnProperty(option[j].optionSet[l]),'is true',
                    'option[j].optionSet[l]=',option[j].optionSet[l])  */
                     
                     if (DEFAULT_ATTR_VALUE.hasOwnProperty(option[j].optionSet[l])
                     && option[j].effect_attr ==='show' && option[j].effect_value ===false
                     && option[j].option.includes(state[option[j].optionSet[l]])
                     )
                      {
                     //   console.log('DONE CHANGES')
                     newState[option[j].optionSet[l]]=DEFAULT_ATTR_VALUE[option[j].optionSet[l]]
                     if (option[j].optionSet[l] === 'ren')
                       newState['renl']=DEFAULT_ATTR_VALUE['renl']
                     if (option[j].optionSet[l] === 'ben')
                       newState['benl']=DEFAULT_ATTR_VALUE['benl']
                      } 
                      
                    
                 }
                } 
                  //break  
                }
               }
              }
            }  
           } 
           else {
            // only optionSet 
            for (let l in option[j].optionSet) {
              if (!res_options.hasOwnProperty(option[j].optionSet[l])){
                res_options[option[j].optionSet[l]] = state['options_'+ option[j].optionSet[l]]
              }  
              if (!option[j].hasOwnProperty('if_attr'))
              {   
                // no if_attr
              res_options[option[j].optionSet[l]][option[j].effect_attr] = option[j].effect_value
                  if (DEFAULT_ATTR_VALUE.hasOwnProperty(option[j].optionSet[l])&& option[j].effect_attr ==='show' && option[j].effect_value ===false)
                   { // console.log('set default value in menu',option[j].optionSet[l],DEFAULT_ATTR_VALUE[option[j].optionSet[l]])
                      newState[option[j].optionSet[l]]=DEFAULT_ATTR_VALUE[option[j].optionSet[l]]
                  }
              }
              else {
                //console.log('start IF-ATTR2',option[j],option[j].optionSet[l]) 
                //console.log('condition',option[j].if_value.indexOf(state[option[j].if_attr]) !== -1 ,DEFAULT_ATTR_VALUE.hasOwnProperty(option[j].optionSet[l])) 
                if (option[j].if_value.indexOf(state[option[j].if_attr]) !== -1 && DEFAULT_ATTR_VALUE.hasOwnProperty(option[j].optionSet[l]))
                { 
                  //console.log('old',res_options[option[j].optionSet[l]][option[j].effect_attr],res_options[option[j].optionSet[l]],res_options)
                  res_options[option[j].optionSet[l]][option[j].effect_attr] = option[j].effect_value
                  //console.log('new',res_options[option[j].optionSet[l]][option[j].effect_attr],res_options[option[j].optionSet[l]],res_options)
                  
                  //console.log('updated',option[j].optionSet[l],'attr=',option[j].effect_attr,'to', option[j].effect_value,res_options)
                  if (DEFAULT_ATTR_VALUE.hasOwnProperty(option[j].optionSet[l])&& option[j].effect_attr ==='show' && option[j].effect_value ===false)
                   { // console.log('set default value in menu',option[j].optionSet[l],DEFAULT_ATTR_VALUE[option[j].optionSet[l]])
                      newState[option[j].optionSet[l]]=DEFAULT_ATTR_VALUE[option[j].optionSet[l]]
                  }
                  
                  
                 
               }
              } 
            }  
           }
          }
        }
      }
    }  
  }
  //console.log('ALL EXTRA UPDATED',res_options)
  for (let i in res_options) {
    newState['options_'+i]=res_options[i]
  }
  // update band if ring was changed
  let all_ring_options =["ds","dctw","dq",
      "head","sh",
      "ren",
      "rmet","rmetc",'hmetc']
      //console.log('try to update band',action.attr,state['band'],newState)
    if (all_ring_options.includes(action.attr) && state['band'] !== '0' ) 
    
    {
        if (action.attr ==='ren') {newState['ben']= action.value}   // else {newState['ben']= state['ren']}
        if (action.attr ==='rmet') {newState['bmet']= action.value}  //  else {newState['bmet']= state['rmet']}
        if (action.attr ==='rmetc') {newState['bmetc']= action.value} //   else {newState['bmetc']= state['smetc']}
     //   console.log('updated band',newState)
      }
      
      if (action.attr==='rmet' && action.value === 'PT'  ){
        newState['rmetc']= 'W'
        newState['hmetc']= 'W'
        newState['bmet']= 'PT'
        newState['bmetc']= 'W'
        
        
      }
      if (action.attr==='band' && action.value !== '0' ) 
      {
          
          newState['ben']= state['ren']
          newState['bmet']= state['rmet']
          newState['bmetc']= state['rmetc']
          //console.log('updated band',newState)
          
        }
        if (action.attr==='head' && action.value === 'N' ) 
          newState['hmetc'] =  state['rmetc']
        if (action.attr==='head' && action.value === 'S' && state['head'] === 'N' ) 
          newState['hmetc'] =  state['rmetc']
        if (action.attr==='head' && action.value === 'D' && state['head'] === 'N' ) 
          newState['hmetc'] =  state['rmetc']
        if (action.attr==='rmetc' && state['head'] === 'N' ) 
          newState['hmetc'] =  action.value
        
              
      /*"rs",
      "band",
      "bset","bsetc","bsetl","ben","benl",
      "bmet","bmetc",*/
      
      
          newState[action.attr] =action.value //.toString()
  //        console.log('last newstate',newState)
          return newState



}



export default function reducer(state = INITIAL_STATE, action) {
  if (action.attr !== undefined && action.value === state['action.attr']){
 //  console.log('useless reducer for ',action.attr,'=',action.value)
   return state
  }
    //console.log('try start reducer',state['ud'],action,state)
   var all_dynamic_options= ['ce','cec','ds','dctw','head', 'headc','sh',
   'pkb','pkbc','rset','rsetc','rsetl','ren','renl','band','bset',
   'bsetc','bsetl','rmet','rmetc',"hmetc","dcl","dct",
   'bmet','bmetc','rs','ben','benl',"dq","loading","ud","isposterminal"]
    var newState
    var newState2
    var refParam
    switch (action.type) {
      case 'REDUX-LOCATION-POP-ACTION':
       if (action.object !== undefined)
       {
        //action.object['sku']=action.object['sku']
       // console.log('from reducer.js 361',state.sku,state.zalessku)

        let refParam = sku2array(action.object['sku']) 
        for (let i in refParam )
        {
     //   console.log('param',i,refParam[i])
         action.object[i]= refParam[i]
        }
       }
       return  Object.assign({}, state, {...action.object});      
      case ACTIONS.START_OVER:
       // console.log('reducer start_over1',state.start_over_init,state);
        var json2 = JSON.parse(JSON.stringify(state.start_over_init));
        json2['showReview'] =false
        json2['sku']=get_default_sku()
        json2['er']=''
        //console.log('from reducer.js 377',state.sku,state.zalessku)

        refParam = sku2array(get_default_sku()) 
        for (let i in refParam )
        {
         //console.log('param',i,refParam[i])
         json2[i]= refParam[i]
        }
        json2['er'] =''
        json2['loading'] ='new'
        json2['eb1'] =''
        
        //json2['sku']=get_sku(state)
       // console.log('reducer start_over',json2,state);
         //      newState2.active_view ='1'
//        return  Object.assign({}, state, {...state.start_over_init, ...newState2});
        return  Object.assign({}, state, {...START_OVER_STATE,...json2});
        case ACTIONS.ZALESSKU:
            //console.log('BEFORE ZALES SKU',action,action.object.value)
            newState=state
             newState['sku']=action.object.value
             newState['cfg1']= action.object.value
             newState['zalessku']= ''
           //  console.log('from reducer.js 400',state.sku,state.zalessku)

             refParam = sku2array(action.object.value) 
             for (let i in refParam )
             {
           //    console.log('paramH',i,refParam[i])
               newState[i]= refParam[i]
             }
            // newState['active_view']=1
             //console.log('AFTER ZALES SKU',refParam)
             newState2={};
             var i;
             for (i in all_dynamic_options)
             if (newState.hasOwnProperty(all_dynamic_options[i]))
               {
                let val={attr:all_dynamic_options[i],value:newState[all_dynamic_options[i]]}
               // console.log('Iteration',i,all_dynamic_options[i],val)  
               // console.log('Iteration2',i,all_dynamic_options[i],controlLogic(newState,val))  
              newState2= controlLogic(newState,val);
              }
            //  console.log('AFTER HISTORY',newState,newState2)
            
             return  Object.assign({}, state, {...newState,...newState2});
     case ACTIONS.HISTORY:
      //console.log('history',action,state);
      if (state.zalessku !== '' ){return state}
      //if (state.zalessku !== '' || action.value === state.sku){return state}
      newState=state
       newState['sku']=action.value
       newState['cfg1']= action.value
      // console.log('from reducer.js 428',state.sku,state.zalessku,state)
     
       refParam = sku2array(action.value) 
       for (let i in refParam )
       {
     //    console.log('paramH',i,refParam[i])
         newState[i]= refParam[i]
       }
 
      // newState['active_view']=1
      // console.log('AFTER HISTORY SKU',newState['ud'],refParam)
       newState2={};
       
       for (i in all_dynamic_options)
       if (newState.hasOwnProperty(all_dynamic_options[i]))
         {
          let val={attr:all_dynamic_options[i],value:newState[all_dynamic_options[i]]}
         // console.log('Iteration',i,all_dynamic_options[i],val)  
         // console.log('Iteration2',i,all_dynamic_options[i],controlLogic(newState,val))  
        newState2= controlLogic(newState,val);
        }
        if (state['er'] !==''){
          newState2['loading-ring'] ='new'
        }
        //state['loading-'+ownProps.product]
        //console.log('AFTER HISTORY',newState,newState2)
        
       return  Object.assign({}, state, {...newState,...newState2});      
    case ACTIONS.LOAD_JSON:
       state.json='loaded'
      
       // var newShowReview ={}
        //console.log('reducer load_json',state);
        let options = action.object['options_all']

        // check all url parameters to match to available options
        for (let i in options ){
          let defaultValue = DEFAULT_STATE_VALUE
          if (options[i] ==='f') {
            defaultValue = '0'
          }
          if  (['er','eb1','eb2'].indexOf(options[i]) === -1  ) {
            if (state.hasOwnProperty(options[i]) !== DEFAULT_STATE_VALUE){
              let correctValue = false
      //        console.log('opt',i,options[i],action)
              for (let j in action.object['options_'+options[i]].options) {
                 //console.log('in for',action.object['options_'+options[i]] , state[options[i]])
                 if  (action.object['options_'+options[i]].options[j].value === state[options[i]]){
                   correctValue =true
                   break
                 }
              }
              if (correctValue === false) {
                //console.log('orig val',options[i],state[options[i]])
                state[options[i]]=defaultValue
                //console.log('changed val to default',options[i])
              }
            }
          }
          else {
          // option e
          for (let j in action.object['options_'+options[i]].options) {
             let type = 'engraving'

             if (action.object['options_'+options[i]].options[j].hasOwnProperty('filter')){
                type=action.object['options_'+options[i]].options[j]['filter']
             }   
           //  console.log('in for',type,action.object['options_'+options[i]].options[j].maxLength ,options[i], state[action.object['options_'+options[i]].options[j]])
             state[action.object['options_'+options[i]].options[j].attr] =filter(state[action.object['options_'+options[i]].options[j].attr],
             type,action.object['options_'+options[i]].options[j].maxLength)
            // console.log('result filter',action.object['options_'+options[i]].options[j].attr,state[action.object['options_'+options[i]].options[j].attr])
          }
        }
      }
       // console.log('json.showReview',state,action)
        if (action.object['showReview'] === false)
         for (let i in options ){
           // need better test on init values fir show review
          if (options[i] !== 'e' && options[i] !== 'f' && state[options[i]] !== DEFAULT_STATE_VALUE) {
          // console.log('json.showReview found',options[i],state[options[i]] )
            action.object['showReview'] =true
           break
        }
        
       }
      // console.log('json.showReview2',newShowReview,state,action)
       if (action.object['sku'] !== undefined &&action.object['sku'] !== state.sku)
       {
       //action.object['sku']=action.object['sku']
      // console.log('from reducer.js 517',state.sku,state.zalessku)

       refParam = sku2array(action.object['sku']) 
       for (let i in refParam )
       {
    //     console.log('param',i,refParam[i])
         action.object[i]= refParam[i]
       }
      } 
       action.object['active_view']=1
    //    console.log('AFTER JSON INIT',action.object)
        newState={};
      //var i;
        for (i in all_dynamic_options)
        if (action.object.hasOwnProperty(all_dynamic_options[i]))
         {
          let val={attr:all_dynamic_options[i],value:action.object[all_dynamic_options[i]]}
     //     console.log('Iteration',i,all_dynamic_options[i],val)  
     //     console.log('Iteration2',i,all_dynamic_options[i],controlLogic(action.object,val))  
        newState= controlLogic(action.object,val);
        }
        //if (state['isposterminal']==='true' ||newState['isposterminal']==='true'){
      //  if (action.object['isposterminal']==='true' ||state['isposterminal']==='true'){
        //    let getOp=action.object['options_ud']
          //console.log('AFTER getOp',getOp,action.object)
         // getOp['show']=true
         // newState['options_ud']=getOp
       // }
        //console.log('AFTER JSON INIT2',newState)
        return  Object.assign({}, state, {...newState,...action.object});      
      case ACTIONS.FORCE_UPDATE:
        newState={};
        newState2= controlLogic(state,action,newState2);
         // console.log('start reducer force',state,action,newState2)
          newState[action.attr]=action.value
          //newState['sku']=get_sku(state)
         // console.log('newState2 force',newState2, {...newState, ...newState2})
        /* if (action.attr==='band' && action.value ==='0') 
            {newState['max_views']=3}
         else   
            {newState['max_views']=5}*/
         return  Object.assign({}, state, {...newState, ...newState2});
        
       //return state
     //  case ACTIONS.HISTORY:

       case ACTIONS.UPDATE:
        newState={};
        newState2= controlLogic(state,action);
        if (action.attr === "ud" && action.value === 'D'&& state['dq'] === 'U'){
          newState={'dq':'I'}
          }
  
   //     console.log('check start reducer',state,newState2)
        if (action.attr === "message"){
          newState={'message':''}
          }
  if (action.attr === "rs" && action.value !== '0'){
                newState={'message':''}
                }
              if (state[action.attr] !==action.value){
          //console.log('start reducer>',state,action,newState,newState2)
          newState[action.attr]=action.value
          let resObj = Object.assign({}, state, {...newState, ...newState2}); 
          //resObj['sku']=get_sku(resObj)
    //      console.log('start changing sku because of ',action.attr,newState2)  
          //console.log('resobj',resObj['ud'],resObj,state, newState,newState2)  
    //      console.log('state',state)  
          if (all_dynamic_options.indexOf(action.attr) !== -1) {
          var state1 ={}  
          state1['ds']=checkNewValue(state,newState2,'ds')
          state1['dctw']=checkNewValue(state,newState2,'dctw')
          state1['head']=checkNewValue(state,newState2,'head')
          state1['sh']=checkNewValue(state,newState2,'sh')
          state1['ren']=checkNewValue(state,newState2,'ren')
          state1['band']=checkNewValue(state,newState2,'band')
          state1['rmet']=checkNewValue(state,newState2,'rmet')
          state1['rmetc']=checkNewValue(state,newState2,'rmetc')
          state1['hmetc']=checkNewValue(state,newState2,'hmetc')
          state1['bmet']=checkNewValue(state,newState2,'bmet')
          state1['bmetc']=checkNewValue(state,newState2,'bmetc')
          state1['rs']=checkNewValue(state,newState2,'rs')
          state1['ben']=checkNewValue(state,newState2,'ben')
          
          state1['dq']=checkNewValue(state,newState2,'dq')
          state1['store']=checkNewValue(state,newState2,'store')
    //      state1['ud']=checkNewValue(state,newState2,'ud')
          state1[action.attr]=action.value
          //if (state1['ud'] === 'U' ||newState2['ud'] === 'U'||state['ud'] === 'U')
          //if (state1['ud'] === 'U' || (state1['ud'] === undefined && state['ud'] === 'U'))
          //   state1['dq']= 'U'
          //else if   (state1['dq'] === 'U')
          //  state1['dq']= 'I'
         /* else if ((state['ud1'] === 'D'||state1['ud'] === 'D' ||newState2['ud'] === 'D') && state['dq']=== 'U')      
          state1['dq']= 'I'*/
          //console.log('old new UD',state1,state,newState2)
          var newsku=param2sku(
            ['R',state1['ds'],state1['dctw'],state1['dq'],state1['sh'],state1['head'],state1['ren'],
            state1['rmet'],state1['rmetc'],state1['rs'],
            state1['store'],state1['band'],state1['ben'],state1['bmet'],state1['bmetc'],state1['hmetc'],'D'
            ])
            resObj['sku']= newsku[0]
            resObj['cfg1']= newsku[0]
            resObj['sku-error']= newsku[1]
          //  console.log('new sku','R',state1['ds'],state1['dctw'],state1['dq'],state1['sh'],state1['head'],state1['ren'],
          //  state1['rmet'],state1['rmetc'],state1['rs'],
          //  state1['store'],state1['band'],state1['ben'],state1['bmet'],state1['bmetc'],state1['hmetc'],'D')
            }
          
          //newState2= controlLogic(resObj,action);
          //console.log('newState2',newState2, {...newState, ...newState2})
          return resObj  
        }
       return state
      default:
       // console.log('default reducer with no logic',state,action)
        return state
    }
    
  }


// WEBPACK FOOTER //
// ./src/reducers/reducer.js